<script setup lang="ts">
import { ref } from 'vue';
import { useNotifyStore } from '@/store/modules/notify';

defineOptions({
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Notification'
});

const notifyStore = useNotifyStore();

const drawerVisible = ref(false);
</script>

<template>
  <NBadge :value="notifyStore.unreadCount" :max="99" :offset="[-8, 2]">
    <ButtonIcon @click="drawerVisible = true">
      <icon-material-symbols-notifications-rounded />
    </ButtonIcon>
  </NBadge>
  <NotificationDrawer v-model:visible="drawerVisible"></NotificationDrawer>
</template>

<style scoped></style>
